import script from "./kobteFilm.vue?vue&type=script&setup=true&lang=js"
export * from "./kobteFilm.vue?vue&type=script&setup=true&lang=js"

import "./kobteFilm.vue?vue&type=style&index=0&id=457f7ba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457f7ba4"]])

export default __exports__